export const successStories = [
  {
    id: 'mai-man',
    couple: 'Mai & Man',
    image: '/img/success-stories/maiman.jpg',
    testimonial: [
      'เว็บงานแต่งออกมาอบอุ่น น่ารัก และพร้อมใช้งานมากๆ ค่ะ ❤️ เลือกใส่ข้อความตามใจได้ ออกแบบหน้าตาแบบที่อยากได้เลย ตัวเว็บยังช่วยนับจำนวนแขกง่ายขึ้น สรุป slip การโอนหลังจบงาน แบบไม่ต้องไปไล่ถามเลย สะดวกสุดๆ 👍',
      'ส่วนน้องบอทก็เข้าถึงง่ายมากค่ะ แขกหลายๆคน ชอบมาก สามารถเรียกดูข้อมูลงานได้เลย เท่มากๆ ใช้แทนการ์ดเชิญยังได้เลยค่ะ 😄',
      'ขอบคุณทีมงานมากๆค่ะที่เติมเต็มงานแต่งออกมาสมบูรณ์มากขึ้น 🤎',
    ],
  },
  {
    id: 'kookkai-aui',
    couple: 'Kookkai & Aui',
    image: '/img/success-stories/kookaiaui.jpg',
    testimonial: [
      'ตอบโจทย์สำหรับงานแต่งงานยุคนี้มากๆ เพราะสามารถเข้ามาช่วยอำนวยความสะดวกในการ ประกาศข่าวสาร RSVP E-card และคำอวยพรแบบ real time ที่เข้ามาร่วมสนุกกันและเก็บเป็นความทรงจำได้ รวมทั้งพื้นที่แสดงข้อมูลบ่าวสาวแบบน่ารักๆ ทางทีมออกแบบให้มีการเข้าเว็บผ่านช่องทาง line และ ai คอยตอบแชทใน line official ช่วยให้แขกเข้าถึงง่ายสุดๆ',
      'ต้องขอบคุณทีมงามมากๆที่สามารถเข้ามาแก้ไขปัญหาให้บ่าวสาวจนสิ่งนี้เข้ามาเป็นส่วนสำคัญกับงานในด้านข้อมูลและประชาสัมพันธ์ ทีมงานคอยเชื่อเหลืออย่างเร็ว รับฟังไอเดียทั้งยังช่วยคิด เสนอไอเดีย และมีความ professional มากๆครับ ขอบคุณมากๆครับ',
    ],
  },
];
